import { CafFormConstants } from "../constants/cafform.constants";

const CafFormReducer = (state, action) => {
  switch (action.type) {
    case CafFormConstants.FETCH_CAF_FORM_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case CafFormConstants.FETCH_CAF_FORM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cafForms: action.payload.data,
        paging: action.payload.paging,
      };
    case CafFormConstants.FETCH_CAF_FORM_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case CafFormConstants.CAF_FORM_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case CafFormConstants.CAF_FORM_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cafFormSearchResults: action.payload,
      };
    case CafFormConstants.CAF_FORM_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case CafFormConstants.CAF_FORM_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case CafFormConstants.CAF_FORM_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cafFormAutoSearchResults: action.payload,
      };
    case CafFormConstants.CAF_FORM_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case CafFormConstants.ADD_CAF_FORM_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case CafFormConstants.ADD_CAF_FORM_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case CafFormConstants.ADD_CAF_FORM_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
        errorMessage: action.payload.message,
      };

    case CafFormConstants.GET_CAF_FORM_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case CafFormConstants.GET_CAF_FORM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cafForm: action.payload,
      };
    case CafFormConstants.GET_CAF_FORM_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case CafFormConstants.UPDATE_CAF_FORM_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case CafFormConstants.UPDATE_CAF_FORM_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        cafForm: action.payload,
      };
    case CafFormConstants.UPDATE_CAF_FORM_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
      };
    case CafFormConstants.DOWNLOAD_CAF_FORM_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case CafFormConstants.DOWNLOAD_CAF_FORM_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case CafFormConstants.DOWNLOAD_CAF_FORM_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case CafFormConstants.UPLOAD_CAF_FORM_REQUEST:
      return {
        ...state,
        isUpload: true,
        uploadError: false,
      };
    case CafFormConstants.UPLOAD_CAF_FORM_SUCCESS:
      return {
        ...state,
        uploadSuccess: true,
        uploadError: false,
        isUpload: false,
      };
    case CafFormConstants.UPLOAD_CAF_FORM_FAILURE:
      return {
        ...state,
        uploadError: true,
        isUpload: false,
      };
    case CafFormConstants.APPROVE_CAF_FORM_REQUEST:
      return {
        ...state,
        isApprove: true,
        approveError: false,
      };
    case CafFormConstants.APPROVE_CAF_FORM_SUCCESS:
      return {
        ...state,
        approveSuccess: true,
        approveError: false,
        isApprove: false,
      };
    case CafFormConstants.APPROVE_CAF_FORM_FAILURE:
      return {
        ...state,
        approveError: true,
        isApprove: false,
      };
    case CafFormConstants.REJECT_CAF_FORM_REQUEST:
      return {
        ...state,
        isReject: true,
        rejectError: false,
      };
    case CafFormConstants.REJECT_CAF_FORM_SUCCESS:
      return {
        ...state,
        rejectSuccess: true,
        rejectError: false,
        isReject: false,
      };
    case CafFormConstants.REJECT_CAF_FORM_FAILURE:
      return {
        ...state,
        rejectError: true,
        isReject: false,
      };

    default:
      return state;
  }
};

export default CafFormReducer;
